module.exports = __webpack_public_path__ + "images/uralsib-86e198d6.png";